import React, {
    useMemo,
    useState,
} from "react";

import {
    platformAudiences,
} from "../../content/platform-audiences";
import LandingArrowIcon from "../../ui/LandingArrowIcon";
import LandingCheckIcon from "../../ui/LandingCheckIcon";

export default function AudienceCapabilitiesCard({
    t,
}) {
    const [
        activeAudienceId,
        setActiveAudienceId,
    ] = useState(
        platformAudiences[0].id
    );

    const activeAudience = useMemo(
        () =>
            platformAudiences.find(
                (audience) =>
                    audience.id ===
                    activeAudienceId
            ) ||
            platformAudiences[0],
        [activeAudienceId]
    );

    return (
        <article className="capabilities-audience">
            <div
                className="capabilities-audience__tabs"
                role="tablist"
                aria-label={t(
                    "main.landing.capabilities.audienceTabsAriaLabel"
                )}
            >
                {platformAudiences.map(
                    (audience) => {
                        const active =
                            audience.id ===
                            activeAudienceId;

                        const tabId =
                            `capabilities-audience-tab-${audience.id}`;

                        return (
                            <button
                                id={
                                    tabId
                                }
                                className={`capabilities-audience__tab${
                                    active
                                        ? " capabilities-audience__tab--active"
                                        : ""
                                }`}
                                type="button"
                                role="tab"
                                aria-selected={
                                    active
                                }
                                aria-controls="capabilities-audience-panel"
                                onClick={() =>
                                    setActiveAudienceId(
                                        audience.id
                                    )
                                }
                                key={
                                    audience.id
                                }
                            >
                                {t(
                                    audience.labelKey
                                )}
                            </button>
                        );
                    }
                )}
            </div>

            <div
                id="capabilities-audience-panel"
                className="capabilities-audience__content"
                role="tabpanel"
                aria-labelledby={
                    `capabilities-audience-tab-${activeAudience.id}`
                }
            >
                <div
                    className="capabilities-audience__body"
                    key={
                        activeAudience.id
                    }
                >
                    <span className="capabilities-audience__eyebrow">
                        {t(
                            activeAudience.eyebrowKey
                        )}
                    </span>

                    <h3>
                        {t(
                            activeAudience.titleKey
                        )}
                    </h3>

                    <p>
                        {t(
                            activeAudience.descriptionKey
                        )}
                    </p>

                    <ul>
                        {activeAudience.featureKeys.map(
                            (featureKey) => (
                                <li key={featureKey}>
                                    <span className="capabilities-audience__check">
                                        <LandingCheckIcon/>
                                    </span>

                                    <span>
                                        {t(
                                            featureKey
                                        )}
                                    </span>
                                </li>
                            )
                        )}
                    </ul>
                </div>

                <div className="capabilities-audience__actions">
                    <a
                        className="capabilities-audience__button"
                        href="/register"
                    >
                        {t(
                            activeAudience.actionKey
                        )}

                        <LandingArrowIcon/>
                    </a>

                    <a
                        className="capabilities-audience__link"
                        href={
                            activeAudience
                                .secondaryAction
                                .href
                        }
                    >
                        {t(
                            activeAudience
                                .secondaryAction
                                .labelKey
                        )}
                    </a>
                </div>
            </div>
        </article>
    );
}
